export const CONFIG_BY_TYPE = {
  MEETINGS_BY_REP: {
    title: 'Top performers',
    subtitle: 'Who’s booking the most meetings?',
    column_titles: ['Drift teammate', 'Meetings booked'],
    tooltip_text:
      'All meetings booked through Drift including playbooks,\nmanual calendar drops, and emails',
  },
  CALLS_BY_REP: {
    title: 'Who’s making the most calls?',
    column_titles: ['Drift teammate', 'Calls made'],
    tooltip_text: 'All calls made through Drift',
  },
  URL: {
    title: 'Where are site visitors starting conversations?',
    column_titles: ['Conversation URL', '# of conversations'],
    tooltip_text:
      'These are the most common URLs your\nsite visitors are starting conversations from',
  },
  REP: {
    title: 'Who’s responding to the most new conversations?',
    column_titles: ['Drift teammate', '# of conversations'],
    tooltip_text:
      'The teammate who was first to send a message in a conversation',
  },
  TAG: {
    title: 'How are conversations being tagged?',
    column_titles: ['Tag', 'Source', '# of conversations'],
    tooltip_text:
      'These are most frequently used conversation tags\nadded by the bot or a teammate',
  },
  DEFLECTION_RATE_BY_PLAYBOOK: {
    title: 'How often did this playbook deflect site visitors?',
    column_titles: ['Support playbook', 'Status', 'Deflection rate'],
  },
  CSAT_BY_TEAMMATE: {
    title: 'CSAT by teammates',
    column_titles: [
      'Teammate',
      'Average CSAT rating',
      'Rated Conversations',
      'Last rated',
    ],
  },
}
